import React, { useEffect, useRef, useState } from "react";
import Participant from "./participant";
import "./ChimeVideoConsultationVideoChild.scss";
import { FullscreenExitOutlined, ExpandOutlined } from "@ant-design/icons";
import { Row, Col, Space, Card, Button, Popover, message } from "antd";
import utils from "utils";
import icons from "Common/Icons";
import { Link } from "react-router-dom";
import Draggable from "react-draggable";
import { connect, useSelector } from "react-redux";
import { CONSTANTS } from "utils/constant";
import CommonButton from "Components/CommonButton";
import ChimeMeetingPanel from "Pages/MyProfile/ChimeMeetingPanel";
import {
  useLocalAudioOutput,
  useLocalVideo,
  useMeetingManager,
  useToggleLocalMute,
} from "amazon-chime-sdk-component-library-react";
import { MeetingSessionConfiguration } from "amazon-chime-sdk-js";
import api from "utils/api";
import { MeetingSessionStatusCode } from "amazon-chime-sdk-js";
import { IconAiForm } from "Common/ReactIcons";
import { IconMicMuted } from "Common/ReactIcons";
import { IconVideoMuted } from "Common/ReactIcons";
import { IconMaximizeScreen } from "Common/ReactIcons";
import { IconMinimizeScreen } from "Common/ReactIcons";
import { IconEndCall } from "Common/ReactIcons";
import { IconMic } from "Common/ReactIcons";
import { IconVideo, IconFormItemCall } from "Common/ReactIcons";

let timer = null;

const ChimeVideoConsultationVideoChild = ({
  is_doctor,
  remoteusr,
  videocallDetails,
  showChat,
  toggleChat,
  meetingData,
  attendeeData,
  returnToLobby,
  patient_id,
  toggleAIForm,
  is_show_ai_form,
  patientDetail,
  toggleDrawerForm,
}) => {
  const [timerOn, setTimerOn] = useState(false);
  const [timerStart, setTimerStart] = useState(0);
  const [timerTime, setTimerTime] = useState(0);
  const [totalTime, setTotalTime] = useState(0);
  const [add_open, setAddOpen] = useState(false);
  const [audio_mute, setAudioMute] = useState(false);
  const [video_mute, setVideoMute] = useState(false);
  const [showMinVideo, setShowMinVideo] = useState(false);
  const [noRemoteVideoViewShow, setNoRemoteVideoView] = useState(true);
  const timerTimeRef = useRef(0);
  // const [showChat, setShowChat] = useState();

  const meetingManager = useMeetingManager();
  const { isVideoEnabled, toggleVideo } = useLocalVideo();
  // const { isAudioOn, toggleAudio } = useLocalAudioOutput();
  const { muted, toggleMute } = useToggleLocalMute();

  const minvideoVisible = useSelector(
    (state) => state.videoConsultationReducer.minvideoVisible
  );
  // useEffect(() => {
  //   if (!is_doctor) {
  //     const meeting_id = meetingData.MeetingId;
  //     api.set_trancribe({
  //       meeting_id,
  //       action: "start",
  //     });
  //     return () => {
  //       api.set_trancribe({
  //         meeting_id,
  //         action: "stop",
  //       });
  //     };
  //   }
  // }, []);

  // const toggleVideoHandler = () => {
  //   toggleVideo(); // This will toggle the video on/off
  // };
  const listenTranscript = () => {
    const audioVideo = meetingManager.audioVideo;
    if (audioVideo && audioVideo.transcriptionController) {
      meetingManager.audioVideo.transcriptionController?.subscribeToTranscriptEvent(
        (transcriptEvent) => {
          const transcriptResults = transcriptEvent?.results || [];
          console.log("############### TranscriptEvent ###############");
          console.log(transcriptEvent);
          console.log("##############################");

          console.log("###############Results###############");
          console.log(transcriptResults);
          console.log("##############################");

          transcriptResults.forEach((result) => {
            console.log(result);
            console.log("result----->");
            if (!result.isPartial) {
              const transcriptionText = result.alternatives[0].transcript;
              console.log("Transcription:", transcriptionText);
              console.log();
              // document.getElementById(
              //   "transcriptionText"
              // ).innerText += `${transcriptionText}\n`;
            }
          });
        }
      );
    }
  };
  const removeTranscript = () => {
    const audioVideo = meetingManager.audioVideo;
    if (audioVideo && audioVideo.transcriptionController) {
      audioVideo.transcriptionController.unsubscribeFromTranscriptEvent();
    }
  };
  const observer = {
    audioVideoDidStart: () => {
      message.success("AudioVideo started");
    },
    audioVideoDidStop: (status) => {
      if (
        status.statusCode() === MeetingSessionStatusCode.OK ||
        status.statusCode() === MeetingSessionStatusCode.Left
      ) {
        message.success("AudioVideo stopped");
      } else {
        message.error(
          `AudioVideo stopped: ${MeetingSessionStatusCode[status.statusCode()]}`
        );
      }
    },
    audioVideoDidFail: (status) => {
      message.error(
        `AudioVideo failed: ${MeetingSessionStatusCode[status.statusCode()]}`
      );
    },
  };
  const joinMeeting = async () => {
    const meetingSessionConfiguration = new MeetingSessionConfiguration(
      meetingData,
      attendeeData
    );
    startTimer();
    await meetingManager.join(meetingSessionConfiguration);

    await meetingManager.start();
    // listenTranscript();
    meetingManager?.audioVideo?.addObserver(observer);
    meetingManager?.audioVideo?.realtimeSubscribeToAttendeeIdPresence(
      (attendeeId, present) => {
        if (attendeeId != attendeeData.AttendeeId) {
          setNoRemoteVideoView(!present);
          message.success(
            `${utils.FormatName(
              utils.getDisplayName(
                remoteusr,
                videocallDetails.remoteUserLastName
              )
            )} ${present ? "Joined" : "Leaved"}`
          );
        }
      }
    );
  };

  const disableAudioTrack = () => {
    // setAudioMute(isAudioOn);
    setAudioMute(muted);
    // toggleAudio();
    toggleMute();
  };

  const disableVideoTrack = () => {
    setVideoMute(isVideoEnabled);
    toggleVideo();
  };

  const leaveRoom = async () => {
    // removeTranscript();
    meetingManager?.audioVideo?.realtimeUnsubscribeToAttendeeIdPresence();
    meetingManager?.audioVideo?.removeObserver();
    await meetingManager.leave();
    const timerTime = timerTimeRef.current;
    let totalDuration =
      (Math.floor(timerTime / 3600000) > 9
        ? Math.floor(timerTime / 3600000)
        : `0${Math.floor(timerTime / 3600000)}`) +
      ":" +
      (Math.floor(timerTime / 60000) % 60 < 9
        ? `0${Math.floor(timerTime / 60000) % 60}`
        : Math.floor(timerTime / 60000) % 60) +
      ":" +
      (Math.floor(timerTime / 1000) % 60 < 9
        ? `0${Math.floor(timerTime / 1000) % 60}`
        : Math.floor(timerTime / 1000) % 60);
    returnToLobby(totalDuration);
    // this.props.returnToLobby(totalDuration, this.props.room?.sid);
  };

  const openPopup = (action) => {
    setTotalTime(("0" + (Math.floor(timerTime / 60000) % 60)).slice(-2));
    leaveRoom();

    if (action === "add") {
      // this.setState({ add_open: true });
      utils.Modal(false);
    }

    // this.setState({
    //   totalTime: ("0" + (Math.floor(this.state.timerTime / 60000) % 60)).slice(
    //     -2
    //   ),
    // });
    // leaveRoom();

    // if (action === "add") {
    //   this.setState({ add_open: true });
    //   utils.Modal(false);
    // }
  };

  const startTimer = () => {
    setTimerOn(true);
    setTimerTime(0);
    const timerStartInitial = Date.now() - timerTime;
    setTimerStart(timerStartInitial);
    timer = setInterval(() => {
      setTimerTime(Date.now() - timerStartInitial);
      timerTimeRef.current = Date.now() - timerStartInitial;
      // this.setState({
      //   timerTime: Date.now() - this.state.timerStart,
      // });
    }, 10);

    // this.setState({
    //   timerOn: true,
    //   timerTime: this.state.timerTime,
    //   timerStart: Date.now() - this.state.timerTime,
    // });
    // this.timer = setInterval(() => {
    //   this.setState({
    //     timerTime: Date.now() - this.state.timerStart,
    //   });
    // }, 10);
  };

  const stopTimer = () => {
    // this.setState({ timerOn: false });
    setTimerOn(false);
    clearInterval(timer);
  };

  const resetTimer = () => {
    setTimerStart(0);
    setTimerTime(0);
    // this.setState({
    //   timerStart: 0,
    //   timerTime: 0,
    // });
  };

  const openCloseModal = () => {
    utils.Modal(true, {
      content: (
        <div className="closeVideo-Modal">
          <div className="closeVideo-header">{CONSTANTS.CONFIRMATION}</div>
          <div className="closeVideo-wrapper">
            <div className="closeVideo-title">
              {is_doctor
                ? " Do you want to close this video call?"
                : "Do you want to end this consultation?"}
            </div>
            <div className="closeVideo-btns">
              <CommonButton
                label={CONSTANTS.YES}
                onClick={() => openPopup("add")}
                className="common-button-green"
              />
              <CommonButton
                label={CONSTANTS.NO}
                className="common-button-white"
                onClick={() => utils.Modal(false)}
              />
            </div>
          </div>
        </div>
      ),
      width: "550px",
    });
  };

  const getTherapy = () => {
    utils.Modal(true, {
      content: <img src={icons.therapy_values}></img>,
      width: "850px",
    });
  };

  const HoverOn = () => {
    this.setState({ isShown: true });
  };

  const HoverOff = () => {
    this.setState({ isShown: false });
  };

  const handleScroll = (event) => {
    // const target = event.target;
    // if (target.scrollHeight - target.scrollTop - target.clientHeight <= 400) {
    //   this.setState({ showMinVideo: true });
    // } else this.setState({ showMinVideo: false });
  };
  // chatToggle() {
  //   // this.props.toggleChat && this.props.toggleChat(false)
  // }

  useEffect(() => {
    joinMeeting();

    // window.addEventListener("beforeunload", leaveRoom);
    localStorage.setItem("patient_id", patient_id || "");
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      // this.leaveRoom();
      // window.removeEventListener("scroll", this.handleScroll, true);
      leaveRoom();
    };
  }, []);

  return (
    // const { timerTime } = this.state;
    // let centiseconds = ("0" + (Math.floor(timerTime / 10) % 100)).slice(-2);
    // let seconds = ("0" + (Math.floor(timerTime / 1000) % 60)).slice(-2);
    // let minutes = ("0" + (Math.floor(timerTime / 60000) % 60)).slice(-2);
    // let hours = ("0" + Math.floor(timerTime / 3600000)).slice(-2);

    <div className="VC ">
      {is_doctor === true &&
      minvideoVisible === true &&
      // this.state.remoteParticipants.length > 0 ? (
      false ? (
        <>
          {/* <Draggable>
        <div className="minVideoWindow">
          {this.state.remoteParticipants.map((participant) => (
            <Participant
              key={participant.identity}
              localParticipant="notLocalParticipant"
              participant={participant}
            />
          ))}
        </div>
      </Draggable> */}
        </>
      ) : (
        <></>
      )}

      <Card size="small">
        <div className="d-flex justify-content-between position-relative d-none">
          <div>
            <span className="red-dot"></span>
            <h3 className="d-inline">Live Consultation</h3>
            {is_doctor === true ? (
              <>
                <h4 className="m-3">
                  <Link
                    to={{ pathname: "/doctor/health-profile" }}
                    target="_blank"
                  >
                    See{" "}
                    {utils.FirstNameLastName(
                      utils.FormatName(
                        utils.getDisplayName(
                          remoteusr,
                          videocallDetails.remoteUserLastName
                        )
                      ),
                      "200px"
                    )}{" "}
                    HI
                  </Link>{" "}
                </h4>
              </>
            ) : (
              <>
                <h4 className="m-3">
                  {utils.FirstNameLastName(
                    utils.FormatName(
                      utils.getDisplayName(
                        remoteusr,
                        videocallDetails.remoteUserLastName
                      )
                    ),
                    "200px"
                  )}
                </h4>
              </>
            )}
          </div>
          <div>
            <h3>
              Call Duration{" "}
              <span className="red-text">
                {/* {hours} : {minutes} : {seconds} */}
                {("0" + Math.floor(timerTime / 3600000)).slice(-2)} :{" "}
                {("0" + (Math.floor(timerTime / 60000) % 60)).slice(-2)} :{" "}
                {("0" + (Math.floor(timerTime / 1000) % 60)).slice(-2)}
              </span>
            </h3>
            {showChat ? (
              <div
                className="chat-div"
                // style={{ float: "right" }}
              >
                <Button onClick={() => toggleChat()}>Chat </Button>
              </div>
            ) : null}
          </div>
        </div>
        {/* {
      !this.props.is_doctor && (
        <div className="therapy-details">
          {this.state.isShown && (
            <div
              className="therapy-details-summary"
              onMouseLeave={this.HoverOff.bind(this)}
              onClick={this.getTherapy.bind(this)}
            >
              Psychotherapeutic Intake details
            </div>
          )}
          <button
            className="therapy-details-button"
            onMouseEnter={this.HoverOn.bind(this)}
          >
            ?
          </button>
        </div>
      )
    } */}
        <Row gutter={16}>
          <Col className="gutter-row" span={24} style={{ padding: "0px" }}>
            <div className="vh-80">
              {/* <img src={placeholdersmall} width="100%"></img> */}
              <div className="position-relative">
                {/* {this.state.remoteParticipants.length === 0 ? ( */}
                {false ? (
                  <div className="waitingRoom ant-row ant-row-space-around ant-row-middle">
                    <h4 className="w-100">
                      Please wait for
                      {utils.FirstNameLastName(
                        utils.FormatName(
                          utils.getDisplayName(
                            remoteusr,
                            videocallDetails.remoteUserLastName
                          )
                        ),
                        "250px",
                        "white"
                      )}
                      to join.....
                    </h4>
                  </div>
                ) : (
                  <>
                    <ChimeMeetingPanel
                      is_doctor={is_doctor}
                      meetingData={meetingData}
                      attendeeData={attendeeData}
                      returnToLobby={returnToLobby}
                      remoteusr={remoteusr}
                      remoteUserLastName={videocallDetails?.remoteUserLastName}
                      noRemoteVideoViewShow={noRemoteVideoViewShow}
                      patientDetail={patientDetail}
                    />
                    {/* {this.state.remoteParticipants.map((participant) => (
                  <Participant
                    key={participant.identity}
                    localParticipant="notLocalParticipant"
                    participant={participant}
                  />
                ))} */}
                  </>
                )}
                {/* <Participant
              key={this.props.room.localParticipant.identity}
              localParticipant="participant"
              local="true"
              participant={this.props.room.localParticipant}
            /> */}
              </div>
              <div className="video-cons-btn">
                <Space
                  size="middle"
                  style={{ gap: 2 }}
                  className="consult-btn-div"
                >
                  <button
                    // type="button"
                    // className="btn btn-primary btn-mic"
                    className="btn-video-call-option"
                    onClick={disableAudioTrack}
                  >
                    {/* {isAudioOn === false ? ( */}
                    {/* {isAudioOn  */}
                    {!muted ? (
                      // <>
                      //   <svg
                      //     height="25"
                      //     viewBox="0 0 64 64"
                      //     width="25"
                      //     xmlns="http://www.w3.org/2000/svg"
                      //   >
                      //     <g id="Mic">
                      //       <path d="m32 42a8.01062 8.01062 0 0 0 8-8v-16a8 8 0 0 0 -16 0v16a8.01062 8.01062 0 0 0 8 8z" />
                      //       <path d="m43 31a1.00011 1.00011 0 0 0 -1 1v2a10 10 0 0 1 -20 0v-2a1 1 0 0 0 -2 0v2a12.00981 12.00981 0 0 0 11 11.94931v6.05069h-5a1 1 0 0 0 0 2h12a1 1 0 0 0 0-2h-5v-6.05069a12.00981 12.00981 0 0 0 11-11.94931v-2a1.00011 1.00011 0 0 0 -1-1z" />
                      //     </g>
                      //   </svg>
                      // </>
                      <IconMic />
                    ) : (
                      // <>
                      //   <svg
                      //     height="25"
                      //     viewBox="0 0 64 64"
                      //     width="25"
                      //     xmlns="http://www.w3.org/2000/svg"
                      //   >
                      //     <g id="Mic_Off" data-name="Mic Off">
                      //       <path d="m40 25v9a7.99087 7.99087 0 0 1 -14.46 4.7l14.28-14.28a1.02289 1.02289 0 0 1 .18.58z" />
                      //       <path d="m44 32v2a12.00888 12.00888 0 0 1 -11 11.95v6.05h5a1 1 0 0 1 0 2h-12a1 1 0 0 1 0-2h5v-6.06a11.77961 11.77961 0 0 1 -8.31-4.39l1.42-1.42a9.87578 9.87578 0 0 0 7.89 3.87 10.0165 10.0165 0 0 0 10-10v-2a1 1 0 0 1 2 0z" />
                      //       <path d="m44.71 16.71-26 26a1.01414 1.01414 0 0 1 -1.42 0 1.008 1.008 0 0 1 0-1.42l3.38-3.37a11.74125 11.74125 0 0 1 -.67-3.92v-2a1 1 0 0 1 2 0v2a9.86939 9.86939 0 0 0 .28 2.31l1.74-1.74c-.01-.18-.02-.37-.02-.57v-16a8 8 0 1 1 16 0v.59l3.29-3.3a1.00409 1.00409 0 0 1 1.42 1.42z" />
                      //     </g>
                      //   </svg>
                      // </>
                      <IconMicMuted />
                    )}
                  </button>
                  <button
                    type="button"
                    // className="btn btn-primary btn-video"
                    className="btn-video-call-option"
                    onClick={disableVideoTrack}
                  >
                    {/* {isVideoEnabled === false ? ( */}
                    {isVideoEnabled ? (
                      // <>
                      //   <svg
                      //     id="solid"
                      //     height="20"
                      //     viewBox="0 0 16 16"
                      //     width="20"
                      //     xmlns="http://www.w3.org/2000/svg"
                      //   >
                      //     <path d="m15.763 4.075c-.146-.091-.332-.1-.486-.022l-3.277 1.638v-1.191c0-.827-.673-1.5-1.5-1.5h-9c-.827 0-1.5.673-1.5 1.5v7c0 .827.673 1.5 1.5 1.5h9c.827 0 1.5-.673 1.5-1.5v-1.191l3.276 1.638c.154.077.338.07.486-.022.148-.091.238-.252.238-.425v-7c0-.173-.09-.334-.237-.425z" />
                      //   </svg>
                      // </>
                      <IconVideo />
                    ) : (
                      // <>
                      //   <svg
                      //     id="solid"
                      //     height="20"
                      //     viewBox="0 0 16 16"
                      //     width="20"
                      //     xmlns="http://www.w3.org/2000/svg"
                      //   >
                      //     <g>
                      //       <path d="m.98 12.9 9.86-9.86c-.11-.03-.22-.04-.34-.04h-9c-.83 0-1.5.67-1.5 1.5v7c0 .65.41 1.2.98 1.4z" />
                      //       <path d="m15.28 4.05-3.28 1.64v-.983l3.854-3.854c.195-.195.195-.512 0-.707s-.512-.195-.707 0l-15 15c-.195.195-.195.512 0 .707s.512.195.707 0l2.853-2.853h6.793c.83 0 1.5-.67 1.5-1.5v-1.19l3.28 1.64c.185.079.356.058.48-.02.15-.1.24-.26.24-.43v-7c0-.17-.09-.33-.24-.43-.14-.09-.33-.1-.48-.02z" />
                      //     </g>
                      //   </svg>
                      // </>
                      <IconVideoMuted />
                    )}
                  </button>
                  <button
                    id="leaveRoom"
                    // type="button"
                    onClick={openCloseModal}
                    // className="btn btn-primary end-call-btn mx-3"
                    className="btn-video-call-option"
                  >
                    {/* <svg
                      xmlns="http://www.w3.org/2000/svg"
                      width="18"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M18.48 22.926l-1.193.658c-6.979 3.621-19.082-17.494-12.279-21.484l1.145-.637 3.714 6.467-1.139.632c-2.067 1.245 2.76 9.707 4.879 8.545l1.162-.642 3.711 6.461zm-9.808-22.926l-1.68.975 3.714 6.466 1.681-.975-3.715-6.466zm8.613 14.997l-1.68.975 3.714 6.467 1.681-.975-3.715-6.467z" />
                    </svg> */}
                    <IconEndCall />
                  </button>                  
                  {showChat ? (
                    <button
                      // className=" btn-chat"
                      className="btn-video-call-option"
                      onClick={() => toggleChat()}
                    >
                      {/* <FullscreenExitOutlined style={{ margin: "0px" }} /> */}
                      <IconMinimizeScreen />
                    </button>
                  ) : (
                    <button
                      // className=" btn-chat"
                      className="btn-video-call-option"
                      onClick={() => toggleChat()}
                    >
                      {" "}
                      {/* <ExpandOutlined style={{ margin: "0px" }} /> */}
                      <IconMaximizeScreen />
                    </button>
                  )}
                  {/* {is_doctor && (
                    <button onClick={toggleAIForm}  className="btn-video-call-option" >
                      {is_show_ai_form ? "Hide AI Form" : "Show AI Form"}
                      <IconAiForm />
                    </button>
                  )} */}
                </Space>
                {is_doctor && (
                  <div className="ai-btn-div">                    
                    <button
                      onClick={toggleDrawerForm}
                      className="btn-video-call-option"
                    >
                      <IconFormItemCall />
                    </button>                  
                    <button
                      onClick={toggleAIForm}
                      className="btn-video-call-option"
                    >
                      {/* {is_show_ai_form ? "Hide AI Form" : "Show AI Form"} */}
                      <IconAiForm />
                    </button>
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>
      </Card>
    </div>
  );
};

export default ChimeVideoConsultationVideoChild;
